import { useTheme } from '@mui/material'
import { SQUARE_SIZE as SQUARE } from '../graph/constants'
const SIZE = 26

interface Props extends React.SVGProps<SVGSVGElement> {
  plus?: boolean
  outline?: boolean
  offline?: boolean
  currentColor?: boolean
}

export default function IconEndpoint({ outline, offline, currentColor, ...props }: Props) {
  const { palette } = useTheme()

  return (
    <svg
      width={SIZE}
      height={SIZE}
      viewBox={`0 0 ${SIZE} ${SIZE}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={SIZE / 2 - SQUARE / 2}
        y={SIZE / 2 - SQUARE / 2}
        width={SQUARE}
        height={SQUARE}
        rx={SQUARE / 4}
        ry={SQUARE / 4}
        fill={currentColor ? 'currentColor' : offline ? palette.contrast.low : palette.contrast.high}
        stroke={palette.background.default}
        vectorEffect="non-scaling-stroke"
        strokeWidth={outline ? 2 : 0}
      />
    </svg>
  )
}
